import request from '@/config/request.js'

const ApiHome = request.Home

const TERM_OPTIONS = [
  { label: '春季', value: '春季' },
  { label: '秋季', value: '秋季' },
  { label: '寒假', value: '寒假' },
  { label: '暑假', value: '暑假' }
]

const BASE_FIELD_LIST = [
  { prop: 'area', label: '经营面积', precision: 2, unitDesc: 'm²',sortNo: 1  },
  { prop: 'teacherNum', label: '在校老师总数', precision: 0, unitDesc: '人',sortNo: 2  },
  { prop: 'classTeacherNum', label: '带班老师总数', precision: 0, unitDesc: '人',sortNo: 3  },
  { prop: 'studentNum', label: '在校学生总数', precision: 0, unitDesc: '人',sortNo: 4  },
  { prop: 'classroomNum', label: '校区教室数量', precision: 0, unitDesc: '个',sortNo: 5  },
  { prop: 'nightCapacity', label: '晚辅设计学位数', precision: 0, unitDesc: '人',sortNo: 6  },
  { prop: 'dormitoryNum', label: '校区寝室数量', precision: 0, unitDesc: '个',sortNo: 7  },
  { prop: 'noonCapacity', label: '午托设计床位数', precision: 0, unitDesc: '人',sortNo: 8  },
  // { prop: 'annualIncome', label: '年度确认总收入', precision: 2 },
  // { prop: 'annualCost', label: '年度成本总额', precision: 2 },
  // { prop: 'otherIncome', label: '其他收入', precision: 2 },
  // { prop: 'rentFee', label: '房租', precision: 2 },
  // { prop: 'propertyFee', label: '物业费', precision: 2 },
  // { prop: 'salaryFee', label: '员工工资', precision: 2 },
  // { prop: 'socialFee', label: '社保公积金', precision: 2 },
  // { prop: 'welfareFee', label: '福利费', precision: 2 },
  // { prop: 'bonusFee', label: '奖金', precision: 2 },
  // { prop: 'mealFee', label: '学员餐费', precision: 2 },
  // { prop: 'snackFee', label: '水果点心', precision: 2 },
  // { prop: 'marketFee', label: '招生宣传费', precision: 2 },
  // { prop: 'waterFee', label: '水费', precision: 2 },
  // { prop: 'powerFee', label: '电费', precision: 2 },
  // { prop: 'referralNum', label: '转介绍新签人数', precision: 0 },
  // { prop: 'newSignNum', label: '期间新签总人数', precision: 0 },
  // { prop: 'refundAmt', label: '期间退费总额', precision: 2 },
  // { prop: 'periodIncome', label: '期间总收入', precision: 2 },
  // { prop: 'noonBegin', label: '午托学期初人数', precision: 0 },
  // { prop: 'noonEnd', label: '午托学期末人数', precision: 0 },
  // { prop: 'nightBegin', label: '晚托学期初人数', precision: 0 },
  // { prop: 'nightEnd', label: '晚托学期末人数', precision: 0 },
  // { prop: 'fullBegin', label: '全托学期初人数', precision: 0 },
  // { prop: 'fullEnd', label: '全托学期末人数', precision: 0 },
  // { prop: 'homeworkBegin', label: '作业托学期初人数', precision: 0 },
  // { prop: 'homeworkEnd', label: '作业托学期末人数', precision: 0 }
]

const RESULT_FIELD_LIST = [
  { prop: 'confirmIncome', label: '确认总收入', type: 'amount' },
  { prop: 'totalCost', label: '成本总额', type: 'amount' },
  { prop: 'laborCost', label: '人工总成本', type: 'amount' },
  { prop: 'grossProfit', label: '毛利润', type: 'amount' },
  { prop: 'grossRate', label: '毛利率', type: 'percent' },
  { prop: 'netProfit', label: '净利润', type: 'amount' },
  { prop: 'netRate', label: '净利率', type: 'percent' },
  { prop: 'fillRate', label: '综合满员率', type: 'percent' },
  { prop: 'renewRate', label: '综合续费率', type: 'percent' },
  { prop: 'trainRenewRate', label: '素养培训续费率', type: 'percent' },
  { prop: 'referralRate', label: '转介绍率', type: 'percent' },
  { prop: 'refundRate', label: '退费率', type: 'percent' },
  { prop: 'careIncomeRate', label: '托管收入占比', type: 'percent' },
  { prop: 'nonCareIncomeRate', label: '非托管收入占比', type: 'percent' },
  { prop: 'score', label: '总分', type: 'amount' },
  { prop: 'level', label: '评级', type: 'text' },
  { prop: 'calcVer', label: '计算版本', type: 'text' }
]

const SERVICE_TEMPLATE = [
  { serviceCode: 'NOON_CARE', serviceName: '午托', unitDesc: ' 元/学期', sortNo: 1 },
  { serviceCode: 'EVENING_CARE', serviceName: '晚托', unitDesc: ' 元/学期', sortNo: 2 },
  { serviceCode: 'FULL_CARE', serviceName: '全托', unitDesc: ' 元/学期', sortNo: 3 },
  { serviceCode: 'HOMEWORK_CARE', serviceName: '作业托', unitDesc: ' 元/学期', sortNo: 4 },
  { serviceCode: 'ENTERPRISE_CARE', serviceName: '企事业托', unitDesc: ' 元/学期', sortNo: 5 },
  { serviceCode: 'WINTER_SUMMER_CARE', serviceName: '寒暑假托', unitDesc: ' 元/学期', sortNo: 6 },
  { serviceCode: 'YOUNG_DAILY', serviceName: '幼小衔接日常', unitDesc: ' 元/学期', sortNo: 7 },
  { serviceCode: 'YOUNG_VACATION', serviceName: '幼小衔接寒暑假', unitDesc: '  (元/学期)', sortNo: 8 },
  { serviceCode: 'TRAINING', serviceName: '素养/培训', unitDesc: '  (元/学期)', sortNo: 9 },
  { serviceCode: 'ACTIVITY_STUDY', serviceName: '活动/研学', unitDesc: '  (元/学期)', sortNo: 10 },
  { serviceCode: 'WEEKEND_CARE', serviceName: '周末托', unitDesc: ' 元/学期', sortNo: 11 }
]

const COST_TEMPLATE = [
  { costCode: 'RENT_PROPERTY', costName: '房租物业', sortNo: 1 },
  { costCode: 'WATER_FEE', costName: '水费', sortNo: 2 },
  { costCode: 'POWER_FEE', costName: '电费', sortNo: 3 },
  { costCode: 'REPAIR_FEE', costName: '维修费', sortNo: 4 },
  { costCode: 'RENOVATION_FEE', costName: '校区翻新', sortNo: 5 },
  { costCode: 'SALARY_FEE', costName: '员工工资', sortNo: 6 },
  { costCode: 'CLASS_HOUR_FEE', costName: '课时费', sortNo: 7 },
  { costCode: 'SOCIAL_FEE', costName: '社保公积金', sortNo: 8 },
  { costCode: 'WELFARE_FEE', costName: '福利费', sortNo: 9 },
  { costCode: 'BONUS_FEE', costName: '奖金', sortNo: 10 },
  { costCode: 'MEAL_FEE', costName: '学员餐费', sortNo: 11 },
  { costCode: 'SNACK_FEE', costName: '水果点心', sortNo: 12 },
  { costCode: 'GIFT_FEE', costName: '学生礼品', sortNo: 13 },
  { costCode: 'MARKET_FEE', costName: '招生宣传费', sortNo: 14 },
  { costCode: 'INSURANCE_FEE', costName: '商业保险', sortNo: 15 },
  { costCode: 'DOUBLE_TEACHER_ACCOUNT_FEE', costName: '双师账号', sortNo: 16 },
  { costCode: 'MAX_AI_RECHARGE_FEE', costName: '错题宝充值', sortNo: 17 },
  { costCode: 'MATERIAL_FEE', costName: '课程教材', sortNo: 18 },
  { costCode: 'ZHANG_STUDIO_FEE', costName: '张校长工作室', sortNo: 19 },
  { costCode: 'TALENT_DELIVERY_FEE', costName: '人才输送', sortNo: 20 },
  { costCode: 'TEAM_TRAINING_FEE', costName: '团队培训', sortNo: 21 },
  { costCode: 'BRAND_RENEWAL_FEE', costName: '品牌续费', sortNo: 22 },
  { costCode: 'OTHER_FEE', costName: '其他', sortNo: 23 }
]

const MANAGED_RENEWAL_TEMPLATE = [
  { renewalType: 'MANAGED', itemCode: 'NOON_CARE', itemName: '午托', sortNo: 1 },
  { renewalType: 'MANAGED', itemCode: 'EVENING_CARE', itemName: '晚托', sortNo: 2 },
  { renewalType: 'MANAGED', itemCode: 'FULL_CARE', itemName: '全托', sortNo: 3 },
  { renewalType: 'MANAGED', itemCode: 'HOMEWORK_CARE', itemName: '作业托', sortNo: 4 }
]

const TRAINING_RENEWAL_TEMPLATE = [
  { renewalType: 'TRAINING', itemCode: 'SUBJECT_A', itemName: '科目A', sortNo: 5 },
  { renewalType: 'TRAINING', itemCode: 'SUBJECT_B', itemName: '科目B', sortNo: 6 },
  { renewalType: 'TRAINING', itemCode: 'SUBJECT_C', itemName: '科目C', sortNo: 7 },
  { renewalType: 'TRAINING', itemCode: 'SUBJECT_D', itemName: '科目D', sortNo: 8 },
  { renewalType: 'TRAINING', itemCode: 'SUBJECT_E', itemName: '科目E', sortNo: 9 }
]

const ASSESS_FIELD_KEYS = [
  'id',
  'schoolYear',
  'term',
  'isDefault',
  'assessDate',
  'assessor',
  'area',
  'teacherNum',
  'classTeacherNum',
  'studentNum',
  'noonCapacity',
  'nightCapacity',
  'classroomNum',
  'dormitoryNum',
  'annualIncome',
  'annualCost',
  'otherIncome',
  'referralNum',
  'newSignNum',
  'refundAmt',
  'periodIncome',
  'noonBegin',
  'noonEnd',
  'nightBegin',
  'nightEnd',
  'fullBegin',
  'fullEnd',
  'homeworkBegin',
  'homeworkEnd',
  'remark',
  'confirmIncome',
  'totalCost',
  'laborCost',
  'grossProfit',
  'grossRate',
  'netProfit',
  'netRate',
  'fillRate',
  'renewRate',
  'trainRenewRate',
  'referralRate',
  'refundRate',
  'careIncomeRate',
  'nonCareIncomeRate',
  'score',
  'level',
  'calcVer'
]

function createServices () {
  return SERVICE_TEMPLATE.map(item => {
    return Object.assign({}, item, {
      price: null,
      peopleNum: null,
      income: null
    })
  })
}

function createGrades () {
  const list = []
  for (let i = 1; i <= 9; i++) {
    list.push({
      gradeNo: i,
      gradeName: i + '年级',
      studentNum: null
    })
  }
  return list
}

function createCosts () {
  return COST_TEMPLATE.map(item => {
    return Object.assign({}, item, {
      amount: null
    })
  })
}

function createRenewals () {
  return MANAGED_RENEWAL_TEMPLATE.concat(TRAINING_RENEWAL_TEMPLATE).map(item => {
    return Object.assign({}, item, {
      beginNum: null,
      endNum: null,
      renewalRate: null,
      renewalTypeLabel: item.renewalType === 'MANAGED' ? '托管' : '素养'
    })
  })
}

function createDataForm () {
  return {
    id: '',
    schoolYear: '',
    term: '',
    isDefault: false,
    assessDate: '',
    assessor: '',
    area: null,
    teacherNum: null,
    classTeacherNum: null,
    studentNum: null,
    noonCapacity: null,
    nightCapacity: null,
    classroomNum: null,
    dormitoryNum: null,
    annualIncome: null,
    annualCost: null,
    otherIncome: null,
    referralNum: null,
    newSignNum: null,
    refundAmt: null,
    periodIncome: null,
    noonBegin: null,
    noonEnd: null,
    nightBegin: null,
    nightEnd: null,
    fullBegin: null,
    fullEnd: null,
    homeworkBegin: null,
    homeworkEnd: null,
    remark: '',
    confirmIncome: null,
    totalCost: null,
    laborCost: null,
    grossProfit: null,
    grossRate: null,
    netProfit: null,
    netRate: null,
    fillRate: null,
    renewRate: null,
    trainRenewRate: null,
    referralRate: null,
    refundRate: null,
    careIncomeRate: null,
    nonCareIncomeRate: null,
    score: null,
    level: '',
    calcVer: '',
    services: createServices(),
    costs: createCosts(),
    grades: createGrades(),
    renewals: createRenewals(),
    scores: []
  }
}

function getResponseData (res) {
  if (res && res.assess) return res
  if (res && res.data && res.data.assess) return res.data
  return {}
}

export default {
  data () {
    return {
      visible: false,
      submitLoading: false,
      recalculateLoading: false,
      sectionOpen: {
        baseInfo: true,
        campusBase: true,
        servicePrice: true,
        servicePeople: true,
        serviceIncome: true,
        semesterCost: true,
        grade: true,
        renewal: false,
        result: false,
        score: false
      },
      termOptions: TERM_OPTIONS,
      baseFieldList: BASE_FIELD_LIST,
      resultFieldList: RESULT_FIELD_LIST,
      dataForm: createDataForm(),
      rules: {
        schoolYear: [
          { required: true, message: '请输入学年', trigger: 'blur' }
        ],
        term: [
          { required: true, message: '请选择学期', trigger: 'change' }
        ],
        assessDate: [
          { required: true, message: '请选择评估日期', trigger: 'change' }
        ],
        assessor: [
          { required: true, message: '请输入评估人', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    toggleSection (key) {
      if (!key) return
      this.$set(this.sectionOpen, key, !this.sectionOpen[key])
    },
    getServiceName (service) {
      if (!service) return ''
      return service.serviceName ? String(service.serviceName) : ''
    },
    getServicePriceUnit (service) {
      if (!service) return ''
      const unit = service.unitDesc ? String(service.unitDesc) : ''
      return unit ? ('（' + unit + '）') : ''
    },
    getServicePeopleUnit () {
      return '（人）'
    },
    getServiceIncomeName (service) {
      if (!service) return ''
      const name = this.getServiceName(service)
      return name ? (name + '收入') : ''
    },
    getServiceIncomeUnit () {
      return '（元）'
    },
    getGradeName (grade) {
      if (!grade) return ''
      return grade.gradeName ? String(grade.gradeName) : ''
    },
    getGradeUnit () {
      return '（人）'
    },
    formatAmount (value) {
      if (value === '' || value === null || value === undefined) return '--'
      const num = Number(value)
      if (Number.isNaN(num)) return '--'
      return num.toFixed(2)
    },
    formatPercent (value) {
      if (value === '' || value === null || value === undefined) return '--'
      const num = Number(value)
      if (Number.isNaN(num)) return '--'
      return (num * 100).toFixed(2) + '%'
    },
    resetFormData () {
      this.dataForm = createDataForm()
      this.$nextTick(() => {
        const ref = this.$refs.formRef
        if (ref && ref.clearValidate) ref.clearValidate()
      })
    },
    init (row) {
      this.visible = true
      this.resetFormData()
      if (row && row.id) {
        this.loadDetail(row.id)
      }
    },
    mergeServices (list) {
      const serviceMap = {}
      const source = Array.isArray(list) ? list : []
      source.forEach(item => {
        serviceMap[item.serviceCode] = item
      })
      return createServices().map(item => {
        const current = serviceMap[item.serviceCode]
        return current ? Object.assign({}, item, current) : item
      })
    },
    mergeCosts (list) {
      const costMap = {}
      const source = Array.isArray(list) ? list : []
      source.forEach(item => {
        costMap[item.costCode] = item
      })
      return createCosts().map(item => {
        const current = costMap[item.costCode]
        return current ? Object.assign({}, item, current) : item
      })
    },
    mergeGrades (list) {
      const gradeMap = {}
      const source = Array.isArray(list) ? list : []
      source.forEach(item => {
        gradeMap[item.gradeNo] = item
      })
      return createGrades().map(item => {
        const current = gradeMap[item.gradeNo]
        return current ? Object.assign({}, item, current) : item
      })
    },
    mergeRenewals (list) {
      const renewalMap = {}
      const source = Array.isArray(list) ? list : []
      source.forEach(item => {
        renewalMap[item.renewalType + '_' + item.itemCode] = item
      })
      return createRenewals().map(item => {
        const key = item.renewalType + '_' + item.itemCode
        const current = renewalMap[key]
        return current ? Object.assign({}, item, current) : item
      })
    },
    applyDetailData (res) {
      const detail = getResponseData(res)
      const assess = detail.assess ? detail.assess : {}
      const nextForm = createDataForm()

      ASSESS_FIELD_KEYS.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(assess, key)) {
          nextForm[key] = assess[key]
        }
      })

      nextForm.services = this.mergeServices(detail.services)
      nextForm.costs = this.mergeCosts(detail.costs)
      nextForm.grades = this.mergeGrades(detail.grades)
      nextForm.renewals = this.mergeRenewals(detail.renewals)
      nextForm.scores = Array.isArray(detail.scores) ? detail.scores : []
      this.dataForm = nextForm
    },
    loadDetail (id) {
      ApiHome.zoneHealthGetById.call(this, { id: id }, res => {
        this.applyDetailData(res)
      })
    },
    buildSubmitData () {
      const data = {}
      const form = this.dataForm

      ASSESS_FIELD_KEYS.forEach(key => {
        if (key === 'confirmIncome' ||
          key === 'totalCost' ||
          key === 'laborCost' ||
          key === 'grossProfit' ||
          key === 'grossRate' ||
          key === 'netProfit' ||
          key === 'netRate' ||
          key === 'fillRate' ||
          key === 'renewRate' ||
          key === 'trainRenewRate' ||
          key === 'referralRate' ||
          key === 'refundRate' ||
          key === 'careIncomeRate' ||
          key === 'nonCareIncomeRate' ||
          key === 'score' ||
          key === 'level' ||
          key === 'calcVer') {
          return
        }
        if (form[key] !== '' && form[key] !== null && form[key] !== undefined) {
          data[key] = form[key]
        }
      })

      data.services = form.services.map(item => {
        return {
          serviceCode: item.serviceCode,
          serviceName: item.serviceName,
          unitDesc: item.unitDesc,
          price: item.price,
          peopleNum: item.peopleNum,
          sortNo: item.sortNo
        }
      })

      data.costs = form.costs.map(item => {
        return {
          costCode: item.costCode,
          costName: item.costName,
          amount: item.amount,
          sortNo: item.sortNo
        }
      })

      data.grades = form.grades.map(item => {
        return {
          gradeNo: item.gradeNo,
          gradeName: item.gradeName,
          studentNum: item.studentNum
        }
      })

      data.renewals = form.renewals.map(item => {
        return {
          renewalType: item.renewalType,
          itemCode: item.itemCode,
          itemName: item.itemName,
          beginNum: item.beginNum,
          endNum: item.endNum,
          sortNo: item.sortNo
        }
      })

      return data
    },
    dataFormSubmit () {
      const ref = this.$refs.formRef
      if (!ref || !ref.validate) return
      ref.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        ApiHome.zoneHealthSave.call(this, this.buildSubmitData(), res => {
          this.submitLoading = false
          this.applyDetailData(res)
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          // this.visible = false
          this.$emit('refresh')
        }, () => {
          this.submitLoading = false
        })
      })
    },
    onRecalculate () {
      if (!this.dataForm.id) return
      this.recalculateLoading = true
      ApiHome.zoneHealthRecalculate.call(this, { id: this.dataForm.id }, res => {
        this.recalculateLoading = false
        this.applyDetailData(res)
        this.$message({
          message: '重新计算成功',
          type: 'success'
        })
      }, () => {
        this.recalculateLoading = false
      })
    }
  }
}
